module.exports = __webpack_public_path__ + "img/FR14388.4223812f.svg";